// B7 — shared helpers for the "teacher availability" hint + overlap block used
// by the student / parent / teacher appointment-create screens.

export interface BusyRange { start_time: string; end_time: string } // "HH:MM"

export function hhmmToMin(s: string | null | undefined): number | null {
  if (!s) return null;
  const m = /^(\d{1,2}):(\d{2})/.exec(s);
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
}

/** True if [start, end) overlaps any busy range. Degenerate ranges → false. */
export function overlapsBusy(start: string, end: string, busy: BusyRange[]): boolean {
  const s = hhmmToMin(start);
  const e = hhmmToMin(end);
  if (s == null || e == null || s >= e) return false;
  return busy.some((b) => {
    const bs = hhmmToMin(b.start_time);
    const be = hhmmToMin(b.end_time);
    if (bs == null || be == null) return false;
    return s < be && e > bs; // half-open overlap
  });
}

/** "10:00-10:30, 14:00-14:30" for display. */
export function formatBusyRanges(busy: BusyRange[]): string {
  return busy.map((b) => `${b.start_time}-${b.end_time}`).join(', ');
}
